import React, { useState } from 'react';

function DocumentoForm({ clientes, plantillas, onClose, onSubmit }) {
  const [validationError, setValidationError] = useState(null);
  const [formData, setFormData] = useState({
    cliente_id: '',
    plantilla_id: '',
    notas: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidationError(null);
    const clienteId = formData.cliente_id ? parseInt(formData.cliente_id, 10) : null;
    const plantillaId = formData.plantilla_id ? parseInt(formData.plantilla_id, 10) : null;
    if (!clienteId) {
      setValidationError('Selecciona un cliente.');
      return;
    }
    if (!plantillaId) {
      setValidationError('Selecciona una plantilla.');
      return;
    }
    onSubmit({
      cliente_id: clienteId,
      plantilla_id: plantillaId,
      campos_personalizados: {},
      notas: formData.notas,
    });
  };

  const plantillaSeleccionada = plantillas.find(p => p.id === parseInt(formData.plantilla_id));

  const handleModalClick = (e) => {
    // Permitir cerrar el modal haciendo clic fuera
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal" onClick={handleModalClick}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Generar Documento</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        {validationError && (
          <div className="alert alert-error" style={{ margin: '0 20px 16px' }}>{validationError}</div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Cliente *</label>
            <select
              name="cliente_id"
              value={formData.cliente_id}
              onChange={handleChange}
              required
            >
              <option value="">Selecciona un cliente</option>
              {clientes.map(cliente => (
                <option key={cliente.id} value={cliente.id}>
                  {cliente.nombre} {cliente.apellidos}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Plantilla *</label>
            <select
              name="plantilla_id"
              value={formData.plantilla_id}
              onChange={handleChange}
              required
            >
              <option value="">Selecciona una plantilla</option>
              {plantillas.map(plantilla => (
                <option key={plantilla.id} value={plantilla.id}>
                  {plantilla.nombre}
                </option>
              ))}
            </select>
            {plantillaSeleccionada && plantillaSeleccionada.descripcion && (
              <p style={{ marginTop: '5px', fontSize: '12px', color: '#666' }}>
                {plantillaSeleccionada.descripcion}
              </p>
            )}
          </div>

          <div className="form-group">
            <label>Notas</label>
            <textarea
              name="notas"
              value={formData.notas}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div className="info-box">
            <p><strong>Nota:</strong> Los siguientes campos se rellenarán automáticamente con los datos del cliente:</p>
            <ul>
              <li><strong>Datos personales:</strong> nombre, apellidos, nombre_completo</li>
              <li><strong>Contacto:</strong> email, telefono, direccion, ciudad, codigo_postal</li>
              <li><strong>Fechas:</strong> fecha_nacimiento, fecha_actual</li>
            </ul>
            <p style={{ marginTop: '10px' }}>
              <strong>Uso en plantillas Word:</strong> Usa estos campos con el formato {'{{nombre}}'}, {'{{email}}'}, {'{{telefono}}'}, etc.
            </p>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary">
              Generar Documento
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default DocumentoForm;
